<ng-container
  *ngIf="text && config.features?.productConfiguratorAttributeTypesV2"
>
  <span
    [attr.aria-label]="
      'configurator.a11y.itemDescription'
        | cxTranslate
          : {
              item: productName,
            }
    "
    [innerHTML]="textToShow"
  ></span>

  <button (click)="toggleShowMore()" *ngIf="showMore" tabindex="{{ tabIndex }}">
    <ng-container *ngIf="showHiddenText; else less"
      >&nbsp;... {{ 'configurator.button.less' | cxTranslate }}</ng-container
    >

    <ng-template #less>
      &nbsp;... {{ 'configurator.button.more' | cxTranslate }}</ng-template
    >
  </button>
</ng-container>
